import { SimpleModel } from 'model/SimpleModel';

export namespace Category {
  export interface Shape {
    name: string;
    id?: number;
    isGlobal?: boolean;
  }
}

export class Category extends SimpleModel<Category.Shape> {
  getId(): number {
    return this.get('id');
  }

  isGlobal(): boolean {
    return this.get('isGlobal');
  }

  getName(): string {
    return this.get('name');
  }
}
